// extracted by mini-css-extract-plugin
module.exports = {"cover":"ProjectCover_cover__Ee8Zh","logo":"ProjectCover_logo__rCzP2"};